import { Routes } from '@angular/router';
import { scoreboardAdminGuard } from '../../core/guards';

export const scoreboardRoutes: Routes = [
  {
    path: 'scoreboard/match/:matchId/admin',
    loadComponent: () =>
      import('./pages/admin/scoreboard-admin.component').then((m) => m.ScoreboardAdminComponent),
    canActivate: [scoreboardAdminGuard],
  },
  {
    path: 'scoreboard/match/:matchId/time',
    loadComponent: () =>
      import('./pages/time-admin/time-admin.component').then((m) => m.TimeAdminComponent),
    canActivate: [scoreboardAdminGuard],
  },
  {
    path: 'scoreboard/match/:matchId/graphics',
    loadComponent: () =>
      import('./pages/graphics/graphics-admin.component').then((m) => m.GraphicsAdminComponent),
    canActivate: [scoreboardAdminGuard],
  },
  {
    path: 'scoreboard/match/:matchId/events',
    loadComponent: () =>
      import('./pages/events/events-admin.component').then((m) => m.EventsAdminComponent),
    canActivate: [scoreboardAdminGuard],
  },
  {
    path: 'scoreboard/match/:matchId/hd',
    loadComponent: () =>
      import('./pages/view/scoreboard-view.component').then((m) => m.ScoreboardViewComponent),
    data: { hideNavbar: true, fullscreen: true },
  },
  {
    path: 'scoreboard/match/:matchId/stadium',
    loadComponent: () =>
      import('./pages/stadium-view/stadium-view.component').then((m) => m.StadiumViewComponent),
    data: { hideNavbar: true, fullscreen: true },
  },
];
